import EntryPoint from "Engine/EntryPoint";

export default new class MoneyFormat {
    constructor() {
        this.gameCurrency = 'EUR';
        this.currencyList = {
            'EUR': {
                position: 2,
                divider: ' ',
                zeroCount: 2,
                symbol: null
            },
            'USD': {
                position: 1,
                divider: '',
                zeroCount: 2,
                symbol: '$'
            }
        };
    }

    getCurrencyData(currency) {
        let data = this.currencyList[currency];
        if (!data) {
           data = {
               position: 2,
               divider: ' ',
               zeroCount: 2,
               symbol: ''
           }
        }
        return data;
    }

    /**
     *
     * @param value
     * @param showCurrency
     * @returns {string}
     */
    format(value, showCurrency = true) {
        this.gameCurrency = EntryPoint.GameModel.currency;

        value = value / 100;
        let currencyRules = this.getCurrencyData(this.gameCurrency);
        let currency = currencyRules.symbol ? currencyRules.symbol : this.gameCurrency;
        let text = value.toFixed(currencyRules.zeroCount);
        if(showCurrency) {
            switch (currencyRules.position) {
                case 1:
                    text = currency + currencyRules.divider + value.toFixed(currencyRules.zeroCount);
                    break;
                case 2:
                    text = value.toFixed(currencyRules.zeroCount) + currencyRules.divider + currency;
                    break;
                default:
                    text = value.toFixed(currencyRules.zeroCount);
                    break;
            }
        }

        return text;
    }
}